export class FiltroActividades{
    category:String;
    protocol:String;
    mision:String;
    dateFrom:Date;
    dateUntil:Date;
    state:String;
    orderWhen:String="down";
}